"use client";

import { c as _c } from "react/compiler-runtime";
import { type Marker, MarkerClusterer } from "@googlemaps/markerclusterer";
import { useMap } from "@vis.gl/react-google-maps";
import { useRouter } from "next/navigation";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import MapMarker from "@/app/(main)/_public_components/map-marker";
import { clubMapContext } from "@/context/club-map-context";
import { sidebarContext } from "@/context/sidebar-context";
import useMobile from "@/hooks/use-mobile";
import { ClubRead } from "@/TS/Interfaces/global_interfaces";
interface ClusteredClubMarkersProps {
  clubs: ClubRead[];
  gridSize?: number;
}

/**
 * The ClusteredTreeMarkers component is responsible for integrating the
 * markers with the markerclusterer.
 */
function ClusteredClubMarkers(props) {
  const $ = _c(26);
  const isMobile = useMobile();
  const router = useRouter();
  const clubs = props.clubs;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [markers, setMarkers] = useState(t0);
  useContext(sidebarContext);
  const {
    setClubMapValues
  } = useContext(clubMapContext);
  const map = useMap();
  const clusterer = useRef(null);
  let t1;
  let t2;
  if ($[1] !== map) {
    t1 = () => {
      if (!map || clusterer.current) {
        return;
      }
      clusterer.current = new MarkerClusterer({
        map
      });
    };
    t2 = [map];
    $[1] = map;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[4] !== markers) {
    t3 = () => {
      clusterer.current?.clearMarkers();
      clusterer.current?.addMarkers(Object.values(markers));
    };
    t4 = [markers];
    $[4] = markers;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (marker, key) => {
      setMarkers(prev => {
        if (marker && prev[key]) {
          return prev;
        }
        if (!marker && !prev[key]) {
          return prev;
        }
        if (marker) {
          return {
            ...prev,
            [key]: marker
          };
        } else {
          const newMarkers = {
            ...prev
          };
          delete newMarkers[key];
          return newMarkers;
        }
      });
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const setMarkerRef = t5;
  let t6;
  if ($[8] !== router) {
    t6 = (_event, club) => {
      router.push(`/club/${club.slug}`);
    };
    $[8] = router;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const handleMarkerClick = t6;
  let t7;
  if ($[10] !== isMobile || $[11] !== setClubMapValues) {
    t7 = (event, club_0) => {
      setClubMapValues(prev_0 => ({
        ...prev_0,
        x: isMobile ? null : event.clientX,
        y: isMobile ? null : event.clientY,
        club: club_0,
        isMarkerHover: isMobile ? false : true,
        isPopinHover: false
      }));
    };
    $[10] = isMobile;
    $[11] = setClubMapValues;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const handleMarkerEnter = t7;
  let t8;
  if ($[13] !== setClubMapValues) {
    t8 = () => {
      setClubMapValues(_temp);
    };
    $[13] = setClubMapValues;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const handleMarkerLeave = t8;
  let t9;
  if ($[15] !== clubs || $[16] !== handleMarkerClick || $[17] !== handleMarkerEnter || $[18] !== handleMarkerLeave) {
    let t10;
    if ($[20] !== handleMarkerClick || $[21] !== handleMarkerEnter || $[22] !== handleMarkerLeave) {
      t10 = club_1 => club_1?.postalAddress?.latitude && club_1?.postalAddress?.longitude && <MapMarker ref={marker_0 => setMarkerRef(marker_0, club_1.slug)} key={club_1.slug} club={club_1} position={{
        lat: Number(club_1?.postalAddress?.latitude),
        lng: Number(club_1?.postalAddress?.longitude)
      }} onClick={handleMarkerClick} onMouseEnter={handleMarkerEnter} onMouseLeave={handleMarkerLeave} setMarkerRef={setMarkerRef} />;
      $[20] = handleMarkerClick;
      $[21] = handleMarkerEnter;
      $[22] = handleMarkerLeave;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    t9 = clubs.map(t10);
    $[15] = clubs;
    $[16] = handleMarkerClick;
    $[17] = handleMarkerEnter;
    $[18] = handleMarkerLeave;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const renderClubMapMarkers = t9;
  let t10;
  if ($[24] !== renderClubMapMarkers) {
    t10 = <>{renderClubMapMarkers}</>;
    $[24] = renderClubMapMarkers;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp(prev_1) {
  return {
    ...prev_1,
    isMarkerHover: false
  };
}
export default React.memo(ClusteredClubMarkers);